import _ from 'lodash';
import WixEvent from '../events/WixEvent';

/**
 * @callback $w.HtmlComponentMessageEventHandler
 * @summary Handles events fired when the code in an HtmlComponent sends a message.
 * @param {$w.HtmlComponentMessageEvent} event The HtmlComponent event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class HtmlComponentMessageEvent
 * @summary Event that is fired when the code in an HtmlComponent sends a message.
 * @memberof $w
 * @mixes $w.Event
 */
export default class HtmlComponentMessageEvent extends WixEvent {
    constructor(target, event) {
        super(target, event);
        this.data = _.get(event, 'data');
    }

    /**
     * @member {*} data
     * @label property
     * @summary Gets the event data.
     * @snippet [HtmlComponent-onMessage.es6=Receive a message from an HTML Component]
     * @memberof $w.HtmlComponentMessageEvent
     * @readonly
     */
}
